export default __webpack_public_path__ + "static/14-50a46a540be83a29c310b3172f323fe5.jpg";